import React from 'react';
import Skeleton from 'react-loading-skeleton';
import styled from 'styled-components';
import { lineHeight, theme, toRem } from 'design';
import { H1, H2 } from '../Typography';
import PageLabel from './PageLabel';

const Layout = styled.section`
  position: relative;
  flex-flow: column nowrap;
  justify-content: flex-start;
  align-items: flex-start;
  width: auto;
  height: auto;
  gap: ${toRem(theme.space.sm)};

  span.react-loading-skeleton {
    background-color: ${theme.color.neutral[700]};
    background-image: linear-gradient(90deg, ${theme.color.neutral[800]}, ${theme.color.neutral[700]}, ${theme.color.neutral[800]}) !important;
  }
`;

const Title = styled(H1)`
  width: 100%;
  margin-bottom: 0;
  word-break: break-word;
  color: ${theme.color.white};
  font-size: ${toRem(theme.font.size['6xl'])};
  line-height: ${lineHeight(theme.font.size['6xl'])};
  font-weight: ${theme.font.weight.light};
`;

const Subtitle = styled(H2)`
  margin-top: ${toRem(theme.space.xs)};
  color: ${theme.color.white};
`;

interface IPageTitleProps {
  title: string | React.ReactNode;
  className?: string;
  isLoading?: boolean;
  subtitle?: string | React.ReactNode;
  label?: string;
}

const PageTitle: React.FC<IPageTitleProps> = ({ label, className, isLoading, subtitle, title, ...rest }) => (
  <Layout className={className} {...rest}>
    {label && <PageLabel>{isLoading ? <Skeleton width={20} /> : label}</PageLabel>}
    <Title data-cy="title">{isLoading ? <Skeleton width={250} /> : title}</Title>
    {subtitle && <Subtitle data-cy="subtitle">{isLoading ? <Skeleton width={200} /> : subtitle}</Subtitle>}
  </Layout>
);

export default PageTitle;
